import api from '../api';


const DatahubService = {
    getDatahubVehicleIdentification: async (data, cancelToken) => {
        return api.post(`/api/datahubVehicleIdentification`, data, { cancelToken: cancelToken.token });
    },
    getPricing: async (data, cancelToken) => {
        return api.post(`/api/datahubPricing`, data, { cancelToken: cancelToken.token });
    },
};

export default DatahubService;
